import { Version } from '@angular/core';

export const VERSION = new Version('0.0.0-PLACEHOLDER');
